const LEGACY_SESSION_KEY = "liminl.sessionId";
const CLIENT_FLOW_KEY = "liminl.clientFlowId";

function createClientFlowId(): string {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  if (globalThis.crypto?.getRandomValues) {
    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  throw new Error("Secure browser randomness is unavailable.");
}

export function clearLegacySessionCredential(): void {
  try {
    localStorage.removeItem(LEGACY_SESSION_KEY);
  } catch {
    // localStorage unavailable (private mode / SSR) - non-fatal.
  }
}

export function getClientFlowId(): string {
  try {
    const current = sessionStorage.getItem(CLIENT_FLOW_KEY);
    if (current) return current;
    const next = createClientFlowId();
    sessionStorage.setItem(CLIENT_FLOW_KEY, next);
    return next;
  } catch {
    return "browser-flow";
  }
}

export function clearClientFlow(): void {
  try {
    sessionStorage.removeItem(CLIENT_FLOW_KEY);
  } catch {
    // sessionStorage unavailable - non-fatal.
  }
}
